export default "__VITE_ASSET__KHq036Us__"